// extracted by mini-css-extract-plugin
export default {"btn":"ButtonProfile_btn__mDnFP","active":"ButtonProfile_active__SOMDI"};